import type { JSX } from 'react'

import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import type { TextProps } from '~/components/atoms/Text/Text'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import type { ReportDownloadItemProps } from './ReportDownloadItem'
import ReportDownloadItem from './ReportDownloadItem'

import styles from './ReportDownload.module.css'

export interface ReportDownloadProps {
  title?: string
  summary?: string
  items?: any
  testID?: string
  titleTag?: TextProps['Tag']
  moduleId?: string
}

export default function ReportDownload({
  title,
  summary,
  testID,
  items,
  titleTag = 'h1',
  moduleId,
}: ReportDownloadProps) {
  return (
    <Fixture id={moduleId}>
      <Container>
        <div className={styles.base} data-testid={testID}>
          {(title || summary) && (
            <div className={styles.introContent}>
              <Text
                size={TextSizes.primaryTitleXLrg}
                uppercase
                Tag={titleTag || 'p'}
                className={styles.introContentTitle}
              >
                {title}
              </Text>
              <Text
                size={TextSizes.magSecondaryTitleSml}
                className={styles.introContentSummary}
              >
                {summary}
              </Text>
            </div>
          )}
          <div className={styles.itemList}>
            {items.map(
              (
                item: JSX.IntrinsicAttributes & ReportDownloadItemProps,
                key: any
              ) => (
                <ReportDownloadItem
                  {...item}
                  key={`report-download-item-${key}`}
                />
              )
            )}
          </div>
        </div>
      </Container>
    </Fixture>
  )
}
